// extracted by mini-css-extract-plugin
export default {"body":"modalImport_body__TM6EH","label":"modalImport_label__tDVjA","labelCenter":"modalImport_labelCenter__InNYC"};